import { getAmplitudeCookieValue } from './getAmplitudeCookieValue'

export function getEventId(): number {
  const { lastEventId } = getAmplitudeCookieValue()

  if (lastEventId !== null) {
    const nextEventId = String(Number(lastEventId) + 1)

    return Number(nextEventId)
  }

  // @see about this number in https://www.docs.developers.amplitude.com/analytics/apis/http-v2-api/#keys-for-the-event-argument
  // its not zero because amplitude starts with 1 when use anonymous guide in browser or is first time to track...
  // None user will have a number greater than 19707001
  const aBiggerRandomNumberToDistinguishEventsWithSameUserAndTimestamp = 19707001

  return aBiggerRandomNumberToDistinguishEventsWithSameUserAndTimestamp
}
